import type { TimelineProps } from './Timeline.types';
import './Timeline.scss';

export default function Timeline({ events, className }: TimelineProps) {
  return (
    <ol className={['timeline', className || ''].filter(Boolean).join(' ')}>
      {events.map((ev, i) => {
        const v = ev.variant ?? 'neutral';
        const isLast = i === events.length - 1;
        return (
          <li key={ev.id} className={['timeline__item', `timeline__item--${v}`].join(' ')}>
            <div className="timeline__marker" aria-hidden="true">
              <span className="timeline__dot">{ev.icon ?? null}</span>
              {!isLast ? <span className="timeline__line" /> : null}
            </div>
            <div className="timeline__body">
              <div className="timeline__header">
                <span className="timeline__title">{ev.title}</span>
                {ev.time ? <span className="timeline__time">{ev.time}</span> : null}
              </div>
              {ev.description ? <div className="timeline__description">{ev.description}</div> : null}
            </div>
          </li>
        );
      })}
    </ol>
  );
}
